import * as React from "react";
const SvgSlidersSimple = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: props.size || "1em",
    height: props.size || "1em",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    ...props
  },
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.333 2.4c1.129 0 2.07.801 2.287 1.866h1.913c.258 0 .467.225.467.5 0 .246-.165.45-.383.493l-.084.008h-1.928a2.334 2.334 0 0 1-4.544 0H1.467c-.258 0-.467-.224-.467-.5 0-.246.165-.45.383-.492l.084-.008h6.58A2.334 2.334 0 0 1 10.333 2.4Zm0 .933a1.4 1.4 0 1 0 0 2.8 1.4 1.4 0 0 0 0-2.8Zm-4.666 5.6c1.129 0 2.07.802 2.286 1.867h6.58l.084.008A.492.492 0 0 1 15 11.3c0 .276-.209.5-.467.5l-6.595.001a2.334 2.334 0 0 1-4.543 0L1.467 11.8l-.084-.008A.492.492 0 0 1 1 11.3c0-.276.209-.5.467-.5H3.38a2.334 2.334 0 0 1 2.287-1.867Zm0 .934a1.4 1.4 0 1 0 0 2.8 1.4 1.4 0 0 0 0-2.8Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  )
);
const SvgSlidersSimple$1 = SvgSlidersSimple;
export {
  SvgSlidersSimple$1 as default
};
